const PII_TOKEN_HEAD = "[PII:";

const PII_TOKEN_RE = /\[PII:[^\]\s]{0,32}\]?/g;

export type GuardedProse = {
  text: string;
  hits: number;
};

function containsPiiPlaceholder(text: string): boolean {
  return text.includes(PII_TOKEN_HEAD);
}

const announced = new Set<string>();

function announce(text: string, hits: number): void {
  if (announced.has(text)) return;
  if (announced.size > 256) announced.clear();
  announced.add(text);
  console.warn(
    `pii.unknown_placeholder rendered=${hits} — an assistant turn carried a masking ` +
      `placeholder to the surface. Upstream failed to restore it, or the model invented ` +
      `it; from here the two are indistinguishable. The turn is marked unreliable.`,
  );
}

export function guardPiiPlaceholders(text: string, marker: string): GuardedProse {
  if (!containsPiiPlaceholder(text)) return { text, hits: 0 };

  let hits = 0;
  const guarded = text.replace(PII_TOKEN_RE, () => {
    hits++;
    return marker;
  });

  announce(text, hits);

  return { text: guarded, hits };
}
